import React, { Component } from "react"
import Radium from "higher-order-components/configured-radium/"

class FinePrint extends Component {
  render() {
    return (
      <div style={styles.base}>
        <h3>{this.props.heading}</h3>
        <div>
          <p>Lorem Ipsum</p>
          <h5>Performance</h5>
          <ol style={styles.ol}>
            <li>test</li>
            <li>test</li>
            <li>test</li>
          </ol>
          <h5>Interior</h5>
          <ol style={styles.ol}>
            <li>test</li>
            <li>test</li>
            <li>test</li>
          </ol>
          <h5>Exterior</h5>
          <ol style={styles.ol}>
            <li>test</li>
            <li>test</li>
            <li>test</li>
          </ol>
          <h5>Technology and Safety</h5>
          <ol style={styles.ol}>
            <li>test</li>
            <li>test</li>
            <li>test</li>
          </ol>
        </div>
      </div>
    )
  }
}

const styles = {
  base: {
    textAlign: "left",
    maxWidth: "1200px",
    margin: "auto"
  },
  ol: {
    listStyle: "none"
  }
}
export default Radium(FinePrint)



// WEBPACK FOOTER //
// ./src/containers/fine-print/index.jsx